module.exports = __webpack_public_path__ + "static/media/galeria11.c3fffc1e.jpg";